import Header from "../../components/Headers/Header";
import React, { useEffect, useState } from "react";
import {toastr} from 'react-redux-toastr';
import Select from "react-select";
import { Button, Card, CardHeader, Col, Container, FormGroup, Input, Modal, Row, Table } from "reactstrap";
import country_list from "../../utils/country_list";
import general_fetch from "../../utils/fetch";

const styles = {
	header_row: {
		marginLeft: 0,
	},
	table_header: {
		fontWeight: "bold",
		fontSize: 'small'
	},
	round_status: {
		fontSize: 'small',
		paddingBottom: 0
	},
	nav_pills_rounds: {
		paddingRight: 60,
		marginRight: "0.7rem",
		marginLeft: "0.2rem",
	},
	action_button: {
		margin: 1       
	}
};

const AddGroup = ({open, toggle, mode, cs_org_users, active_bd_group, fetch_bd_groups, bd_reps, bd_rep_map}) => {

	const [group_name, set_group_name] = useState('');
	const [selected_bd_reps, set_selected_bd_reps] = useState([]);

	const add_group = async() => {
		try{
			let body = {bd_rep_ids: selected_bd_reps.map(x => x.value), code: group_name}
			let resp = await general_fetch({url:'bd_group/add', body})
			fetch_bd_groups()
			toastr.success('BD Group created successfully')
			onClick_handleClose()
		}catch(e){
			console.error(e);
			toastr.error(`Couldn't create Bd Group, please try again`)
		}
	}

	const update_group = async() => {
		try{
			let body = {id:active_bd_group.id, bd_rep_ids: selected_bd_reps.map(x => x.value), code: group_name}
			let resp = await general_fetch({url:'bd_group/update', body})
			fetch_bd_groups()
			toastr.success('BD Group updated successfully')
			onClick_handleClose()
		}catch(e){
			console.error(e);
			toastr.error(`Couldn't update BD Group, please try again`)
		}
	}

	const onClick_handleClose = () => {
		set_group_name('')
		set_selected_bd_reps([])
		toggle()
	}

	useEffect(() => {
		if(active_bd_group && bd_rep_map && mode==='edit'){
			if(active_bd_group.code) set_group_name(active_bd_group.code)
			if(active_bd_group.BD_Representatives && active_bd_group.BD_Representatives.length){
				set_selected_bd_reps(active_bd_group.BD_Representatives.map(x => {return {value: x, label: bd_rep_map[x]}}))
			}
		}
	}, [active_bd_group, bd_rep_map, mode]);

	return(
		<Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={onClick_handleClose}>
			<div className="modal-header  bg-gradient-white">
				<h4 className="modal-title" style={{}}>{mode==='add' ? 'Add' : 'Update'} Group</h4>
				<button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={onClick_handleClose}>
				<span aria-hidden={true}>×</span>
				</button>
			</div>
			<div className="modal-body  bg-gradient-secondary" style={{fontSize:'14px'}}>
				<Row>
                    <Col md="12">
                      <FormGroup>
					  	<label className="form-control-label" htmlFor="input-address" >
							Name
                        </label>
                        <Input name="credits" className="form-control-alternative mb-3" type="text" placeholder='Enter Group Name' value={group_name} onChange={(e) => set_group_name(e.target.value)} />
                        <label className="form-control-label" htmlFor="input-address" >
							Select Users
                        </label>
                        {/* <Input name="credits" className="form-control-alternative" type="select" placeholder='Type...' value={selected_bd_reps} onChange={(e) => set_selected_bd_reps(e.target.value)} /> */}
						<Select
                            closeMenuOnSelect={false}
                            // components={animatedComponents}
                            value = {selected_bd_reps}
                            isMulti
                            options={bd_reps && bd_reps.length && bd_reps.map(c => {return {'value': c.id, 'label': bd_rep_map[c.id]}})}
                            // styles={colourStyles}
                            onChange={(selectedOptions) => set_selected_bd_reps(selectedOptions)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
			</div>
			<div className="modal-footer" style={{height:'60px'}}>
				<Button color='primary' disabled={(group_name && selected_bd_reps && selected_bd_reps.length ? false : true)} onClick={mode==='add' ? add_group : update_group}>Submit</Button>
			</div>
		</Modal>
	)
}

const BdGroups = ({user_details, cs_org_users}) => {

	const [add_modal_open, set_add_modal_open] = useState(false);
	const [display_bd_groups, set_display_bd_groups] = useState([]);
	const [mode, set_mode] = useState('');
	const [active_bd_group, set_active_bd_group] = useState();
	const [bd_reps, set_bd_reps] = useState([]);
	const [bd_rep_map, set_bd_rep_map] = useState();

	const toggle_add_modal = () => set_add_modal_open(!add_modal_open)

	const fetch_bd_groups = async() => {
		try{
            var resp = await general_fetch({url: 'bd_group/get'});
			set_display_bd_groups(resp.bd_groups)
		}catch(err){
			console.error(err)
		}
	}

	const fetch_bd_reps = async() => {
		try{
			let resp = await general_fetch({url:'bd_representative/get'})
			let temp_map = {}
			if(resp.bd_representatives && resp.bd_representatives.length){
				resp.bd_representatives.map((bd_rep) => {
					let found_user = cs_org_users.find(o => o.id === bd_rep.user_id)
					temp_map[bd_rep.id] = found_user.first_name
				})
			}
			set_bd_rep_map(temp_map)
			set_bd_reps(resp.bd_representatives)
		}catch(err){
			console.error(err)
		}
	} 

	useEffect(() => {
		if(cs_org_users && cs_org_users.length) {
			fetch_bd_groups()
			fetch_bd_reps()
		}
	}, [cs_org_users]);

	return(
		<>
			<Container fluid>
				<Row>
					<div className="col">
						<Card className="shadow">
							<CardHeader className="border-4 bg-gradient-secondary">
								<Row className='mb-3 mr-3' style={{ display: 'flex', justifyContent: 'end' }}><Button color='primary' onClick={() => {toggle_add_modal();set_mode('add')}}>Add BD Group</Button></Row>
							</CardHeader>
							<div style={{minHeight:'200px'}}>
								<Table className="align-items-center table-flush text-center" responsive>
									<thead className="thead-light text-center">
										<tr style={{ textAlign: 'left' }}>
											<th scope="col"><span style={styles.table_header}><b>S.No</b></span>&nbsp;</th>
											<th scope="col"><span style={styles.table_header}><b>Group Name</b></span>&nbsp;</th>
											<th scope="col"><span style={styles.table_header}><b>Bd Reps</b></span>&nbsp;</th>
											<th scope="col"><span style={styles.table_header}><b>Actions</b></span>&nbsp;</th>
										</tr>
									</thead>
									<tbody>
										{
											display_bd_groups && display_bd_groups.length ? display_bd_groups.map((single_group, idx) => (
												single_group.hidden?'':
												<tr style={{ textAlign: 'left' }}>
													<td scope="col"><span>{idx + 1}</span>&nbsp;</td>
													<td scope="col"><span>{single_group.code ? single_group.code : 'N/A'}</span>&nbsp;</td>
													<td scope="col">
														<div title={single_group.BD_Representatives && single_group.BD_Representatives.length ? single_group.BD_Representatives.map((c, idx) => (bd_rep_map && bd_rep_map[c] ? bd_rep_map[c] : '') + (idx != single_group.BD_Representatives.length-1 ? ', ' : '')).join(' ') : 'N/A'} className=" lines1_elipsis" style={{maxWidth:'300px',}}>
															{single_group.BD_Representatives && single_group.BD_Representatives.length ? single_group.BD_Representatives.map((c, idx) => (bd_rep_map && bd_rep_map[c] ? bd_rep_map[c] : '') + (idx != single_group.BD_Representatives.length-1 ? ', ' : '')).join(' ') : 'N/A'}
														</div>
													</td>
													<td scope="col">
														<i onClick={() => { set_active_bd_group(single_group); toggle_add_modal(); set_mode('edit')}} className="fa fa-edit p-2 cp"></i>
													</td>
												</tr>
											)) : ''
										}
									</tbody>
								</Table>
							</div>
						</Card>
					</div>
				</Row>
				<AddGroup open={add_modal_open} toggle={() => {toggle_add_modal(); set_mode('')}} user_details={user_details} fetch_bd_groups={fetch_bd_groups} active_bd_group={active_bd_group} mode={mode} bd_reps={bd_reps} bd_rep_map={bd_rep_map}/>
			</Container>
		</>
	)
}

export default BdGroups